// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuetify from 'vuetify'
// import colors from 'vuetify/es5/util/colors'
import VueI18n from 'vue-i18n'
import { sync } from 'vuex-router-sync'
import App from './App.vue'
import cognito from '@/utils/cognito.js'
import http from '@/utils/http.js'
import router from '@/router/router.js'
import store from '@/store'
import TreeView from '@/components/TreeView'
import 'es6-promise/auto'
import VueAnalytics from 'vue-analytics'
import 'babel-polyfill'
import FullCalendar from 'vue-full-calendar'
import 'fullcalendar/dist/fullcalendar.min.css'
import HttpHook from '@/plugins/HttpHook'
import utils from '@/utils/utils.js'

Vue.config.productionTip = false

sync(store, router)

// 言語の設定 (default)
let transslationList = {
  'ja': 'japanese',
  'en': 'english',
  'de': 'german',
  'ru': 'russian'
}
let transslations = {}
Object.keys(transslationList).forEach(function (key) {
  transslations[key] = require('./assets/aqua_harps4_com/translations/' + transslationList[key])
})

// ドメイン取得
let domainConfig = utils.getDomainConfig()
let path = domainConfig.path
if (path !== 'aqua_harps4_com') {
  Object.keys(transslationList).forEach(function (key) {
    var whitelabelTransslation = require('./assets/' + path + '/translations/' + transslationList[key])
    Object.keys(whitelabelTransslation).forEach(function (label) {
      if (transslations[key][label] === undefined) {
        transslations[key][label] = whitelabelTransslation[label]
      } else {
        transslations[key][label] = Object.assign(transslations[key][label], whitelabelTransslation[label])
      }
    })
  })
}

Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: 'en',
  messages: transslations,
  fallbackLocale: 'en'
})

// 地域の設定 (enでもUKとUSで日付フォーマットが違う)
// 毎回代入する（stateにはいれない）
let language = (window.navigator.languages && window.navigator.languages[0]) ||
            window.navigator.language ||
            window.navigator.userLanguage ||
            window.navigator.browserLanguage
store.commit('SET_LOCALE', language)

if (window.localStorage) {
  // local storage にあるアカウント情報をチェックして store にセット
  try {
    const localUserString = window.localStorage.getItem('user') || 'null'
    const localUser = JSON.parse(localUserString)

    if (localUser && store.state.user !== localUser) {
      store.commit('SET_USER', localUser)
      store.commit('SET_TOKEN', window.localStorage.getItem('token'))
      store.commit('SET_REFRESHTOKEN', window.localStorage.getItem('refreshToken'))
    }
  } catch (e) {
    console.log(e)
  }

  // 設定パラメータ
  try {
    const settingParamsString = window.localStorage.getItem('settingParams') || 'null'
    const settingParams = JSON.parse(settingParamsString)
    if (settingParams && settingParams.unit) {
      store.commit('SET_SETTINGPARAMS', settingParams)
    }
  } catch (e) {
    console.log(e)
  }

  // StartGuide
  try {
    let showStartGuide = true
    const showStartGuideString = window.localStorage.getItem('showStartGuide')
    if (showStartGuideString !== null) {
      const parsed = JSON.parse(showStartGuideString)
      showStartGuide = parsed.showStartGuide
    }
    store.commit('SET_SHOWSTARTGUIDE', showStartGuide)
  } catch (e) {
    console.log(e)
  }

  // 言語の設定をリストア
  try {
    let language
    const languageString = window.localStorage.getItem('language')
    if (languageString !== null) {
      const parsed = JSON.parse(languageString)
      language = parsed.language
    } else {
      // ローカルストレージにない場合はブラウザ情報から拾う
      // chrome, safariにより形式が少し異なる。
      // 指定言語以外は英語表記
      if (store.getters.locale === 'ja' || store.getters.locale === 'ja-JP') {
        language = 'ja'
      } else if (store.getters.locale === 'de' || store.getters.locale.indexOf('de-') === 0) {
        language = 'de'
      } else if (store.getters.locale === 'uk' || store.getters.locale.indexOf('uk-') === 0) {
        language = 'ru'
      } else if (store.getters.locale === 'ru' || store.getters.locale.indexOf('ru-') === 0) {
        language = 'ru'
      } else {
        language = 'en'
      }
    }
    i18n.locale = language
  } catch (e) {
    console.log(e)
  }
}

// Pace.js の設定
window.Pace.options.ajax.trackMethods = ['GET', 'POST', 'DELETE', 'PUT', 'PATCH']

// マテリアルコンポーネントフレームワーク
Vue.use(Vuetify, {
  theme: {
    warning: '#FF9300'
  }
})

// カレンダー
Vue.use(FullCalendar)

if (path === 'aqua_harps4_com') {
  // google analytics
  Vue.use(VueAnalytics, {
    id: 'UA-109213674-2',
    router
  })
}

Vue.use(HttpHook)

// 組織の階層表示用。 再帰的に表示するためにここで宣言
Vue.component('tree-view', TreeView)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n: i18n,
  router,
  store,
  template: '<App/>',
  components: { App },
  hoge: { hogehoge: 'hoge' },
  created () {
    this.$httpHookInit()
    http.request('get', '/service2/configs/getCognitoConfigs')
    .then(response => {
      const data = response.data
      cognito.initialize(data.region, data.userPoolId, data.clientId)
    })
    .catch(error => {
      // TODO エラー処理 ログイン画面を出してはいけない
      console.log(
        "http.request('get', '/service2/configs/getCognitoConfigs') failed with:", error)
    })

    // 翻訳されたサービス名をstoreに格納
    // ハードコーディングが必須要件、かつ翻訳データがあるこのタイミングで格納
    let long = [
      null,
      this.$t('service.flow-and-time'),
      this.$t('service.ro-membrane'),
      this.$t('service.temperature'),
      this.$t('service.leakage'),
      this.$t('service.pressure')
    ]
    let short = [
      null,
      this.$t('service-short.flow-and-time'),
      this.$t('service-short.ro-membrane'),
      this.$t('service-short.temperature'),
      this.$t('service-short.leakage'),
      this.$t('service-short.pressure')
    ]
    // タブ表示等で使う識別子。ここで入れなくてもいいけど、管理が楽なのでここで格納
    let code = [null, 'FLOW', 'RO', 'TEMPERA', 'LEAK', 'PRESS']
    this.$store.commit('SET_SERVICELIST', {long, short, code})
  }
})



// WEBPACK FOOTER //
// ./src/main.js